import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { shareReplay, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CreateOrderService {

  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

 getCityList(payload: any) {
    return this.http.post(
      `${this.baseUrl}/customer/master/get-city-list-by-state`,
      payload
    );
  }
  getStateList(payload: any) {
    return this.http.post(
      `${this.baseUrl}/customer/master/get-state-list-by-country`,
      payload
    );
  }
    getDestinationCountry() {
    return this.http.get(
      `${this.baseUrl}/customer/destination-country-list`
    );
  }
  getPincodeList(payload: any) {
    return this.http.post(
      `${this.baseUrl}/customer/master/get-zip-code-by-city`,
      payload
    );
  }
  getSenderPincode(pincode: any) {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-pincode-wise-data?pincode=${pincode}`
    );
  }
  paymentMode(pincode: any) {
    return this.http.get(
      `${this.baseUrl}/customer/master/payment-mode`
    );
  }
  consignorConsigneeType(){
    return this.http.get(
      `${this.baseUrl}/customer/master/consignor-consignee-type`
    ); 
  }
  consignorType(){
     return this.http.get(
      `${this.baseUrl}/customer/master/consignor-type`
    );
  }
  consigneeList(body:any){
     return this.http.post(
      `${this.baseUrl}/customer/consignee/list`,body
    );
  }
 addShippingAddress(body:any){
  return this.http.post(
      `${this.baseUrl}/customer/consignee/add`,body
    );
 }
 consignorList(body:any){
  return this.http.post(
      `${this.baseUrl}/customer/consinor/list`,body
    );
 }

   getWarehouseList(body:any) {
    return this.http.post(
      `${this.baseUrl}/customer/warehouses/list`,body
    );
  }
  addConsignorDetails(body:any){
      return this.http.post(
      `${this.baseUrl}/customer/consinor/add`,body
    );
  }
   addWarehouse(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/warehouses/add`, body
    );

}

  getShipmentCategory(shipmentTypeId: any) {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-shipment-category?MasterCourierShipmentTypeId=${shipmentTypeId}`
    );
  }
  getShipmentType() {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-master-courier-shipment-type`
    );
  }
  // createOrder(body:any){
  //   return this.http.post(
  //     `${this.baseUrl}/customer/create-order`, body
  //   ); 
  // }
  generateOrderId(){
     return this.http.get(
      `${this.baseUrl}/customer/generate-order-id`
    );
  }
    termsAndTrade(){
     return this.http.get(
      `${this.baseUrl}/customer/master/terms-of-trades`
    );
  }
  addOrder(body:any){
     return this.http.post(
      `${this.baseUrl}/customer/create-order`, body
    ); 
  }
  getCurrencyList() {
  return this.http.get(
    `${this.baseUrl}/customer/master/get-currency-list`
  );
}
getHsnDetails(){
  let body = null
   return this.http.post(
    `${this.baseUrl}/customer/master/hsn-code`,body
  );
}


private hsnListCache: any[] = [];

getHsnDetailsCached() {

  if (this.hsnListCache.length) {
    return of({
      status: true,
      data: this.hsnListCache
    });
  }

  return this.getHsnDetails().pipe(
    tap((res: any) => {
      if (res.status) {
        this.hsnListCache = res.data;
      }
    })
  );
}
private userKycVerification$!: Observable<any>;

userKyCVerfication() {
  if (!this.userKycVerification$) {
    this.userKycVerification$ = this.http
      .get(`${this.baseUrl}/customer/user-check-kyc`)
      .pipe(
        shareReplay(1)
      );
  }

  return this.userKycVerification$;
}
clearKycCache() {
  this.userKycVerification$ = undefined as any;
}

getorderList(body:any){
   return this.http.post(
    `${this.baseUrl}/customer/get-order-list`,body
  );
}
 getShipmentDetails(masterCustomOrderId: number) {
    return this.http.post(
      `${this.baseUrl}/customer/order-shipment`,
      {
        orderId: masterCustomOrderId
      }
    );
  }

  getCourierRates(masterCustomOrderId: number) {
    return this.http.post(
      `${this.baseUrl}/customer/list-courier-shipment-price`,
      {
        orderId: masterCustomOrderId
      }
    );
  }

  placeOrder(payload: FormData) {
  return this.http.post(
    `${this.baseUrl}/customer/place-order`,
    payload
  );
}



generateInvoice(payload: any) {
 return this.http.post(
    `${this.baseUrl}/customer/generate-invoice`,
    payload,
    {
      observe: 'response',
      responseType: 'blob'
    }
  );
}

downloadLabel(payload: any) {
  return this.http.post(
    `${this.baseUrl}/customer/download-label`,
    payload,
    { responseType: 'blob' }
  );
}

downloadNetworkLabel(payload: any) {
  return this.http.post(
    `${this.baseUrl}/customer/network-label-download`,
    payload
  );
}
manualOrderStatusList(body:any){
  return this.http.post(`${this.baseUrl}/customer/order-status-list`,body)
}
getCustomDocument(payload: any) {
  return this.http.post(`${this.baseUrl}/customer/get-custom-document`,
    payload
  );

}

uploadDocument(payload: FormData) {
  return this.http.post(`${this.baseUrl}/customer/upload-document`,
    payload
  );

}

}
